module.exports = __webpack_public_path__ + "img/server_blueprint.539a808.webp";